module.exports = __webpack_public_path__ + "img/10-1_05.d17408df.jpg";